<script>import { cx } from "@emotion/css";
import { isFluidProp, ResponsiveVars } from "..";
export let direction = "row";
export let align = "stretch";
export let justify = "flex-start";
export let wrap = "wrap";
export let spacing = void 0;
let cssVarsClassName;
$: {
  const builder = new ResponsiveVars().addResponsive("stack-direction", direction).addResponsive("stack-align", align).addResponsive("stack-justify", justify).addResponsive("stack-wrap", wrap);
  if (spacing) {
    if (isFluidProp(spacing)) {
      builder.addFluid("stack-spacing", spacing);
    } else {
      builder.addResponsive("stack-spacing", spacing, (t) => `var(--twist-core-spacing-${t})`);
    }
  }
  cssVarsClassName = builder.toCSS();
}
</script>

<div class={cx('twist-stack', cssVarsClassName)} data-component="TwistStack">
  <slot />
</div>

<style>
  div {
    display: flex;
    margin: calc(var(--stack-spacing) * -1) 0 0 calc(var(--stack-spacing) * -1);
    width: calc(100% + var(--stack-spacing));
    flex-direction: var(--stack-direction);
    align-items: var(--stack-align);
    justify-content: var(--stack-justify);
    flex-wrap: var(--stack-wrap);
  }

  div :global(> *) {
    margin: var(--stack-spacing) 0 0 var(--stack-spacing);
  }
</style>
